import { render, staticRenderFns } from "./DialogAgreement.vue?vue&type=template&id=d94e70bc&scoped=true&"
import script from "./DialogAgreement.vue?vue&type=script&lang=js&"
export * from "./DialogAgreement.vue?vue&type=script&lang=js&"
import style0 from "./DialogAgreement.vue?vue&type=style&index=0&id=d94e70bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94e70bc",
  null
  
)

export default component.exports